import { CsvImportFilter } from './REPORT_CONFIG';

export const CTV_IMPORT_OPTIONS: Array<CsvImportFilter> = [
  {
    key: 'region',
    label: 'Region',
    type: 'checkbox',
    options: [
      {
        label: 'Global',
        value: 'GLOBAL'
      },
      {
        label: 'APAC',
        value: 'APAC'
      },
      {
        label: 'EMEA',
        value: 'EMEA'
      },
      {
        label: 'LATAM',
        value: 'LATAM'
      },
      {
        label: 'North America',
        value: 'NA'
      }
    ]
  },
  {
    key: 'device',
    label: 'Device',
    type: 'checkbox',
    options: [
      {
        label: 'Roku',
        value: 'roku'
      },
      {
        label: 'FireTV',
        value: 'firetv'
      },
      {
        label: 'tvOS',
        value: 'tvos'
      },
      {
        label: 'Samsung',
        value: 'samsung'
      }
    ]
  },
  {
    key: 'includeSpoofing',
    label: 'Include Spoofing',
    type: 'radio',
    options: [
      {
        label: 'Exclude',
        value: 'F'
      },
      {
        label: 'Include',
        value: 'T'
      }
    ]
  }
];
